import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="relative w-full max-w-md mx-auto" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3.5 rounded-lg border border-background-300 bg-background-50 text-left cursor-pointer hover:border-primary-400 transition-colors"
      >
        <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-grid-line text-primary-500 text-lg" />
          {t("dropdown_label")}
        </span>
        <i className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute z-30 mt-2 w-full max-h-72 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1">
          {categories.map((c) => (
            <a
              key={c.slug}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-5 py-2.5 text-sm text-foreground-800 cursor-pointer hover:bg-primary-50 hover:text-primary-700 transition-colors"
            >
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-foreground-400" />
              </span>
              {t(`cats.${c.slug}`)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}